import React from 'react';
import { memo, useState } from 'react';
import { theme } from '../../theme';
import { BellIcon } from '../../assets';
import { PrimaryButton, SecondaryButton } from '../button';
import { Tooltip } from '../tooltip';
import * as Icons from '../../assets';
import { AuctionSaleItemContent } from '../../types';

const graysRed = theme.colors.primary.graysRed;
const systemGreen = theme.colors.system.systemGreen;

export const NotificationTooltip: React.FC<{
  saleId: string | number;
  content: AuctionSaleItemContent['notification'];
  isNotified: boolean;
  isLoggedIn: boolean;
  onNotification: () => void;
}> = memo(({ saleId, content, isNotified, isLoggedIn, onNotification }) => {
  const [toolTipOpen, s_toolTipOpen] = useState<boolean>(false);

  let icon: keyof typeof Icons = 'BellIcon';
  let color = graysRed;
  let titleText = content.title;
  let bodyText = content.body;
  let callToActionLabel = content.callToAction;

  if (!isLoggedIn) {
    bodyText = content.loggedOut.body;
    callToActionLabel = content.loggedOut.callToAction;
  } else if (isNotified) {
    icon = 'CheckIcon';
    color = systemGreen;
    callToActionLabel = '';
  }

  function handleCallToAction() {
    if (!isLoggedIn) {
      s_toolTipOpen(false);
      history.replaceState(null, '', `#${saleId}`);
    }
    onNotification();
  }
  function toggleToolTip() {
    s_toolTipOpen((p) => !p);
  }

  return (
    <Tooltip
      customTrigger={
        isNotified ? (
          <PrimaryButton contextColor="success" onClick={toggleToolTip}>
            <BellIcon height={24} fill={'white'} />
          </PrimaryButton>
        ) : (
          <SecondaryButton isActive={toolTipOpen} onClick={toggleToolTip}>
            <BellIcon height={24} />
          </SecondaryButton>
        )
      }
      style={{ minWidth: '240px', maxWidth: '240px' }}
      title={{
        text: titleText,
        icon,
        color,
      }}
      text={bodyText}
      placement="bottom-end"
      callToActionType="primary"
      callToActionLabel={callToActionLabel}
      onCallToAction={handleCallToAction}
      setControlledVisible={(visible) =>
        s_toolTipOpen((p) => {
          if (isNotified && p === false) {
            return false;
          }
          return visible;
        })
      }
      trigger={null}
      controlledVisible={toolTipOpen}
    />
  );
});
